<app-lms-modal-frame [title]="getPageName()" [pageHeadWidth]="500">
  <div modal-body>
    <div class="container-fluid center-screen">
    <div id="content-capture">
      <div id="scores" class="scores center-section py-2">
        <span>
          <h6>Scan Quality</h6>
          <input class="form-control fs-5 text-center" type="text" id="qualityInputBox" readonly [ngModel]="readQuality"
            style="background-color:#DCDCDC;">
        </span>
      </div>
      <div id="status"></div>
    </div>

    <div class="my-2">
      <div *ngFor="let data of sampleData; let sampleDataIndex = index;" class="mx-2">
        <label class="mt-2" [for]="'sampleData' + sampleDataIndex">Finger Data {{ sampleDataIndex + 1 }}
        </label>
        <label sampleDataIndex>: Captured success</label>
      </div>
      <div class="center-section">
        <table class="table table-striped table-auto table-hover table-sm my-3 mx-2">
          <tbody class="field-4column-label">
            <tr>
              <td>Branch Manager Username:</td>
              <td>
                <span>
                  <input
                  class="form-control"
                    placeholder="BM Username"
                    [(ngModel)]="biometricsModel.bmUserName"
                    required
                    #bmUsername="ngModel"
                    (input)="onUsernameInput()">
                </span>
                <!-- Show error only when field is empty AND has been touched -->
                <div *ngIf="bmUsername.invalid && (bmUsername.dirty || bmUsername.touched)">
                  <small class="text-danger">Please enter Branch manager username.</small>
                </div>
              </td>
            </tr>
            <tr>
              <td>Verify Finger Response:</td>
              <td>{{enrollmentMessage}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  </div>
  <div modal-actions class="flex-container readerDivButtons mt-2">
    <button class="btn btn-primary btn-sm" type="button"
      [disabled]="!isStartButtonEnabled()"
      (click)="startCapture()">Start</button>
    <button class="btn btn-primary btn-sm ms-3" type="button" (click)="close()">
      Close
    </button>
  </div>
</app-lms-modal-frame>
